function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Path 9");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50.5177218%",
  y1: "96.1200811%",
  x2: "50.5177218%",
  y2: "3.8799189%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F8FFFF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00C1F1",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "DesignContest_Logo-design-landing-page",
  transform: "translate(0.000000, -946.000000)",
  fillRule: "nonzero",
  stroke: "url(#linearGradient-1)"
}, React.createElement("path", {
  d: "M0.544568181,1194 C-9.20264369,1233.33333 111.898966,1253 363.849396,1253 C615.799826,1253 867.750257,1151 1119.70069,947",
  id: "Path-9",
  transform: "translate(559.850344, 1100.000000) scale(-1, 1) translate(-559.850344, -1100.000000) "
})));

var SvgSeeOur1 = function SvgSeeOur1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1121px",
    height: "308px",
    viewBox: "0 0 1121 308",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSeeOur1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/see-our-1.2ca3e7a7.svg";
export { ForwardRef as ReactComponent };